import CalendarDaysOutline from '@adv-mt/mt-svg-icons/lib/CalendarDaysOutline.js'
import CarAutocaravanOutline from '@adv-mt/mt-svg-icons/lib/CarAutocaravanOutline.js'
import CarBuggieOutline from '@adv-mt/mt-svg-icons/lib/CarBuggieOutline.js'
import CarCheckOutline from '@adv-mt/mt-svg-icons/lib/CarCheckOutline.js'
import CarClassicOutline from '@adv-mt/mt-svg-icons/lib/CarClassicOutline.js'
import CarDataOutline from '@adv-mt/mt-svg-icons/lib/CarDataOutline.js'
import CarDeliveryCarOutline from '@adv-mt/mt-svg-icons/lib/CarDeliveryCarOutline.js'
import CarEngineOutline from '@adv-mt/mt-svg-icons/lib/CarEngineOutline.js'
import CarExtraconfortOutline from '@adv-mt/mt-svg-icons/lib/CarExtraconfortOutline.js'
import CarIndustrialOutline from '@adv-mt/mt-svg-icons/lib/CarIndustrialOutline.js'
import CarMiniOutline from '@adv-mt/mt-svg-icons/lib/CarMiniOutline.js'
import CarOutline from '@adv-mt/mt-svg-icons/lib/CarOutline.js'
import CarSparksOutline from '@adv-mt/mt-svg-icons/lib/CarSparksOutline.js'
import CarSportOutline from '@adv-mt/mt-svg-icons/lib/CarSportOutline.js'
import CarVanOutline from '@adv-mt/mt-svg-icons/lib/CarVanOutline.js'
import DoorsOutline from '@adv-mt/mt-svg-icons/lib/DoorsOutline.js'
import Electroutline from '@adv-mt/mt-svg-icons/lib/Electroutline.js'
import KmOdometer from '@adv-mt/mt-svg-icons/lib/KmOdometer.js'
import Leaf from '@adv-mt/mt-svg-icons/lib/Leaf.js'
import MotorcycleClassicOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleClassicOutline.js'
import MotorcycleMiniOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleMiniOutline.js'
import MotorcycleOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleOutline.js'
import MotorcycleQuadOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleQuadOutline.js'
import MotorcycleSizeOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleSizeOutline.js'
import PaletteOutline from '@adv-mt/mt-svg-icons/lib/PaletteOutline.js'
import PoiOutline from '@adv-mt/mt-svg-icons/lib/PoiOutline.js'
import ShieldCheckOutline from '@adv-mt/mt-svg-icons/lib/ShieldCheckOutline.js'
import ShoppingCartOutline from '@adv-mt/mt-svg-icons/lib/ShoppingCartOutline.js'
import TagOutline from '@adv-mt/mt-svg-icons/lib/TagOutline.js'

export const BASE_CLASS_NAME = 'mt-FiltersGroupedByAccordion'

export const ACCORDION_CONTENT_MAX_HEIGHT = '100%'

export const ICONS_MAP = {
  calendar: CalendarDaysOutline,
  car: CarCheckOutline,
  carAutocaravan: CarAutocaravanOutline,
  carBrand: CarDataOutline,
  carBuggie: CarBuggieOutline,
  carClassic: CarClassicOutline,
  carDelivery: CarDeliveryCarOutline,
  carEngine: CarEngineOutline,
  carExtras: CarExtraconfortOutline,
  carIndustrial: CarIndustrialOutline,
  carMini: CarMiniOutline,
  carOutline: CarOutline,
  carSparks: CarSparksOutline,
  carSport: CarSportOutline,
  carVan: CarVanOutline,
  cursorClick: ShoppingCartOutline,
  doors: DoorsOutline,
  ecoLeaf: Leaf,
  electric: Electroutline,
  kmOdometer: KmOdometer,
  moto: MotorcycleOutline,
  motoClassic: MotorcycleClassicOutline,
  motoMini: MotorcycleMiniOutline,
  motoSize: MotorcycleSizeOutline,
  palette: PaletteOutline,
  poi: PoiOutline,
  quad: MotorcycleQuadOutline,
  shieldCheck: ShieldCheckOutline,
  tag: TagOutline
}

export const FILTERS_OPENED_BY_DEFAULT = {}
